import { useState } from "react";

/**
 * Custom Hook to copy text (or current URL) to clipboard with a fallback
 */
const useCopyToClipboard = () => {
  const [copied, setCopied] = useState(false);

  /**
   * Copy text or current URL to clipboard
   * @param {string} [text] - The text to copy (defaults to current URL)
   */
  const copyToClipboard = (text = window.location.href) => {
    if (typeof text !== "string" || text.trim() === "") return;

    const onSuccess = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(() => fallbackCopyText(text, onSuccess));
    } else {
      fallbackCopyText(text, onSuccess);
    }
  };

  /**
   * Fallback method for copying text using execCommand
   */
  const fallbackCopyText = (text, onSuccess) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      if (document.execCommand("copy")) onSuccess();
    } catch (error) {
      console.error("Fallback copy failed:", error);
    }

    document.body.removeChild(textArea);
  };

  return { copied, copyToClipboard };
};

export default useCopyToClipboard;